module.exports = "https://la-static.vkplay.ru/promo/newstart/img/summoner.473d1026.png";